import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {UserInRegListType} from '../../../types/TypesUserProfit';
import TableButtonsActions, {
	ActionConfig,
} from '../../../Components/TableButtonsActions/TableButtonsActions';
import DistributorsTree from '../../../Components/FindDistributorsComponent/DistributorsTree/DistributorsTree';
import {UserClient} from '../../../types/TypesUser';
import arrowMoveIcon from '../../../assets/img/icons/actions/arrow_move.svg';
import giftIcon from '../../../assets/img/icons/actions/gift.svg';
import {useGetClientsRegMoveMutation} from '../../../redux/userClientsApi';
import {handleApiCall} from '../../../assets/utils/utils';
import {monthNow} from '../../../assets/utils/dateUtils';

type Props = {
	user: UserInRegListType;
};

const TableRegistrationActions: React.FC<Props> = ({user}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [showDistributorsTree, setShowDistributorsTree] = useState(false);
	const [moveClient] = useGetClientsRegMoveMutation();

	const handlers = {
		move: async (userId: number) => {
			setShowDistributorsTree(true);
		},
		gift: async (userId: number) => {
			navigate('/my_orders', {
				state: {
					openDeferredPopup: true,
					selectedContract: user.contract,
					userId: userId,
				},
			});
		},
	};

	const handleChangeUser = async (client: UserClient) => {
		await handleApiCall({
			apiCall: () =>
				moveClient({
					client_id: user.user_id,
					new_sponsor_id: client.client_id,
					month: monthNow(),
				}),
			onSuccess: () => {
				setShowDistributorsTree(false);
			},
		});
	};

	const actions: ActionConfig[] = [
		{
			type: 'move',
			icon: arrowMoveIcon,
			label: t('Перемістити в дереві'),
			disabled: () => !user.move_permit,
			handler: handlers.move,
		},
		{
			type: 'gift',
			icon: giftIcon,
			label: t('Оформити бали'),
			disabled: () => user.status !== 'manager',
			handler: handlers.gift,
		},
	];

	return (
		<>
			{showDistributorsTree &&
				createPortal(
					<DistributorsTree
						handleChangeUser={handleChangeUser}
						closePopup={() => setShowDistributorsTree(false)}
					/>,
					document.body,
				)}
			<TableButtonsActions
				actions={actions}
				orderId={user.user_id}
				orderStatus={user.status}
			/>
		</>
	);
};

export default TableRegistrationActions;
